import HorizontalBarChart from './HorizontalBarChart';

export default HorizontalBarChart;
